import { Component } from '@angular/core';

@Component({
  selector: 'cigna-compensation-contact-us',
  templateUrl: './producer-commissions-contact-us-dialog.component.html',
  styleUrls: ['./producer-commissions-contact-us-dialog.component.scss'],
})
export class ProducerCommissionsContactUsDialogComponent {
  constructor() {}
}
